<script setup lang="ts">
import {Tooltip as VTooltip} from 'floating-vue'
import {isNotNullOrUndefined} from '../utils/utils'
import {useNewUiEnabled} from '@/composable/useNewUiEnabled'

interface Props {
  disabled?: boolean
  text?: string
  size?: 'base' | 'large' | 'extra-large'
}

withDefaults(defineProps<Props>(), {size: 'base'})

const isNewUiEnabled = useNewUiEnabled()
</script>

<template>
  <VTooltip
    :class="{'cursor-pointer': isNewUiEnabled}"
    :disabled="disabled"
    :popper-class="size === 'large' ? 'v-popper--size-large' : size === 'extra-large' ? 'v-popper--size-extra-large' : undefined"
    :theme="isNewUiEnabled ? 'Rateboard-new-ui' : 'Rateboard'"
  >
    <slot />

    <template #popper>
      <slot name="tooltip-content">
        <span v-if="isNotNullOrUndefined(text)">{{ text }}</span>
      </slot>
    </template>
  </VTooltip>
</template>
